import { assembleProcessFlow } from "../core/builder";
import { processFlowElkPreset } from "./elkLayeredPreset";
/**
 * Readonly process-flow adapter. `build()` returns the assembled graph
 * (sync, no ELK). Callers that want a positioned graph should run the
 * `layout.run()` preset.
 */ export function createProcessFlowAdapter(registry) {
    return {
        registry,
        layout: processFlowElkPreset,
        features: {
            bridges: true
        },
        build (source) {
            const { process, options } = source;
            const assembly = assembleProcessFlow(process, new Map(), options ?? {});
            return {
                nodes: assembly.nodes,
                edges: assembly.edges
            };
        }
    };
}

//# sourceMappingURL=readOnlyAdapter.js.map